import links from "@/links/links";

export default {
  actions: {
    FETCH(agencyId) {
      return this.get(links.CONFIGURATION_GET_BY_AGENCY(agencyId), {
        dataKey: "hydra:member",
      });
    },    
  },
};
